module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- For Multiple Choice QT this template is for repetitively showing the dropdown list options. This will be applied only when flag Display As List For Visitor is set from portal. -->\r\n<option value=\'' +
((__t = (name )) == null ? '' : __t) +
'\'>' +
((__t = (name )) == null ? '' : __t) +
'</option>';

}
return __p
}